import React from 'react';
import clsx from 'clsx';

import styles from './SidebarArrow.module.scss';

interface SidebarArrowProps {
  isCollapsed: boolean;
  onClick: () => void;
}

export function SidebarArrow({ isCollapsed, onClick }: SidebarArrowProps) {
  return (
    <div
      className={clsx(styles.toggleButton, {
        [styles.outside]: isCollapsed,
      })}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        className={clsx(styles.arrow, { [styles.collapsed]: isCollapsed })}
      >
        <path d="M2 19.5V0.5" stroke="#1E1F1E" strokeWidth="1.5" strokeMiterlimit="10" />
        <path d="M19 10H8" stroke="#1E1F1E" strokeWidth="1.5" strokeMiterlimit="10" />
        <path d="M11.9302 5.23001L7.16016 10L11.9302 14.77" stroke="#1E1F1E" strokeWidth="1.5" strokeMiterlimit="10" />
      </svg>
    </div>
  );
}
